import './oneCredit.scss';

const OneCredit = ({dat}) => {
    const gtag_report_conversion = (url) => {
        var callback = function () {
            if (typeof(url) !== 'undefined') {
                window.open(dat.order, '_blank');
            }
        };
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11521301823/afxVCPLt7fwZEL-65PUq',
            'event_callback': callback,
        });
        return false;
    };
    return (
        <div className="oneCredit">
                <div className="oneCredit__wrapper">
                    <div className="oneCredit__wrapper-img">
                        <img src={dat.screen} alt="screen" />
                    </div>
                    <div className="oneCredit__wrapper-name">
                        <h2>{dat.name}</h2>
                    </div>
                    {/* <div className="oneCredit__wrapper-percent">
                        <h2>{dat.percentPrefix} {dat.percent} {dat.percentPostfix}</h2>
                    </div> */}
                    <a 
                    href={dat.order} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault(); // предотвращаем переход по ссылке
                        gtag_report_conversion(dat.order); // вызываем конверсию
                    }}
                    >
                        {dat.orderButtonText}
                    </a>
                </div>
        </div>
    )
}

export default OneCredit;
